'use strict';

module.exports = {
    guaranteedMargin: 'guaranteedMargin',
    discountOff: 'discountOff',
    nonPromoMargin: 'nonPromoMargin',
    noInvoice: 'noInvoiceFunction',
};
